/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import {Component} from "react";
import React from "react";
import ReactTable from "react-table";
import AxiosClient from "../../../_helpers/http.helper";
import config from "../../../config";
import {formatUrl} from "../../../_helpers/url.format.helper";
import ActionCard from "../../widgets/ActionCard/ActionCard";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";
import {TEXT_TYPES} from "../../../constants/APP_CONSTANTS";
import intersectionBy from "lodash/intersectionBy";
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";
import {Link} from "react-router-dom";

export default class PriceUpdateStatus extends Component {
    state = {
        priceBatches : [],
        selectedBatch: null,
        hasMore: true,
        pageSize: 25,
        pageNumber: null,
        totalItems: 0,
        statusesList: {},
        activeActionCards: [],
        batchStatuses: [],
        selectedStatus: null,
        entityStatusesList: {},
        isModalActive: false,
        isLoading: true,
    };


    componentDidMount() {
        this.getPriceUpdateBatches();

    }

    getPriceUpdateBatches = () => {

        if (!this.state.hasMore) {
            return;
        }

        const priceUpdateBatchURL
            = formatUrl(config.contentService.baseUrl,config.contentService.routes.priceUpdateBatches,
                {
                    queryParams : {
                        pageSize: this.state.pageSize,
                        pageNumber:
                            this.state.pageNumber === null
                                ? 0
                                : this.state.pageNumber + 1
                    }
                }
            );

        AxiosClient.get(priceUpdateBatchURL)
            .then(res => {
                const results = res.data;
                this.setState(prevState => ({
                    priceBatches: intersectionBy([
                        ...prevState.priceBatches,
                        ...results.content
                    ],'batchId'),
                    pageNumber: results.number,
                    totalItems: results.totalElements,
                    hasMore: !results.last,
                    isLoading: false
                }));
            });
    };

    hasMore = () => {
        this.setState({
            hasMore: false
        });
    };


    loadActionCard = () => {
        const batch = this.state.priceBatches.find((item) => item.batchId === this.state.selectedBatch);
        const statusesList = {
            "FAILED" : [],
            "PROCESSING" : [],
            "COMPLETED" : [],

        };

        batch.resourcePriceUpdateStatus.forEach(statusItem => {
            statusesList[statusItem.updateStatus]
                ? statusesList[statusItem.updateStatus].push(statusItem)
                : statusesList[statusItem.updateStatus] = [statusItem];
        });

        return (<div>

            {Object.entries(statusesList).map(([statusName, statusItems], index) => ( (statusItems.length !== 0)
                && <ActionCard
                    className={`action-card-${statusName}`}
                    key={index}
                    headerOnClick={() => this.toggleActionCard(index)}
                    controlsLeft={<div className={`pe-label pe-bold card-title`}>{statusName}</div>}
                    controlsRight={<span className={`badge px-2`}>{statusItems.length}</span>}>
                    {(this.state.activeActionCards.length === 0 || !this.state.activeActionCards.includes(index)) && (
                        <div>
                            <table className="pe-table mb-0">
                                <thead>
                                    <tr>
                                        <th scope="col">Status ID</th>
                                        {statusName !== "Failed" && <th scope="col">Resource ID</th>}
                                        <th scope="col">Resource Title</th>
                                        <th scope="col">ISBN</th>
                                        <th scope="col">Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(statusItems.map((item, id) => (
                                        <tr key={id}>
                                            <td>{item.id}</td>
                                            {statusName !== "Failed" && <th scope="row">{item.resourceId}</th>}
                                            <td>{item.title}</td>
                                            <td>{item.isbn}</td>
                                            <td>{item.comment}</td>
                                        </tr>)
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </ActionCard>)
            )}
        </div>);
    };


    toggleActionCard = index => {
        this.setState(prevState => {
            const prevActive = prevState.activeActionCards;
            return {
                activeActionCards: prevActive.includes(index)
                    ? prevActive.filter(active => active !== index)
                    : prevActive.concat([index])
            };
        });
    };

    render() {
        console.log(this.state.isModalActive);
        const columns = [
            {
                Header: "Batch ID",
                accessor: "batchId",
                sortable: true
            },
            {
                Header: "Resource Count",
                accessor: "resourceCount",
                sortable: true
            },
            {
                Header: "Last Updated Date",
                sortable: true,
                accessor: 'creationDate',
                width: 150,
                Cell: d =>
                    moment(d.value)
                        .utc()
                        .format("MM/DD/YY HH:mm z"),
            }
        ];

        return (
            <div className="cc-migration-status pe-row">
                <div class="title">
                    <label className="pe-page-title--small">
                        {TEXT_TYPES.PRICE_UPDATE_STATUS}
                    </label>
                    <hr />
                </div> {this.state.isLoading && <LoadingIndicator/>}  {this.state.totalItems > 0
                    && <div className="pe-col-4 infiniteScroll" id="scrollTable">
                        <InfiniteScroll
                            dataLength={this.state.priceBatches.length}
                            next={this.getPriceUpdateBatches}
                            loader={<LoadingIndicator isDark={false} />}
                            hasMore={this.state.hasMore}
                            scrollableTarget="scrollTable"
                        >
                            <div className="table-wrap">
                                <ReactTable
                                    className="-highlight"
                                    data={this.state.priceBatches}
                                    showPagination={false}
                                    columns={columns}
                                    defaultPageSize={this.state.totalItems}
                                    minRows={0}
                                    sortable={true}
                                    pageText=""
                                    resizable={false}
                                    noDataText="No Batches found"
                                    getTrProps={(_, rowInfo) => {
                                        return {
                                            style: {
                                                cursor: "pointer",
                                                textAlign: "center"
                                            },
                                            onClick: () => {
                                                this.setState({
                                                    selectedBatch: rowInfo.original.batchId,
                                                    activeActionCards: []
                                                });
                                            }
                                        };
                                    }}
                                />
                            </div>
                        </InfiniteScroll>
                    </div>
                }
                <div className="pe-col-8">
                    {this.state.selectedBatch && this.loadActionCard()}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/ContentManagement/PriceUpdateStatus.js